/**
 * Helper play method which handles the promise returned by the play method
 * 
 * @private
 * @memberof VideoPlayer
 */
export function playVideo(video: HTMLVideoElement): void {
    const play = video.play();
    if(play !== undefined) {
        play.then().catch();
    }
}
